import { createSelector } from 'reselect';

const selectDbnp = (state: any) => state.dbnp;


export const selectDbnpCurrentItem = createSelector([selectDbnp], (dbnp) => dbnp.current);

export const selectDbnpListItems = createSelector([selectDbnp], (dbnp) => dbnp.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDbnpListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDbnpCreatedItem = createSelector([selectDbnp], (dbnp) => dbnp.create);

export const selectDbnpUpdatedItem = createSelector([selectDbnp], (dbnp) => dbnp.update);

export const selectDbnpQueryItems = createSelector([selectDbnp], (dbnp) => dbnp.query);

export const selectDbnpReadItem = createSelector([selectDbnp], (dbnp) => dbnp.read);

export const selectDbnpDeletedItem = createSelector([selectDbnp], (dbnp) => dbnp.delete);

export const selectDbnpSearchedItems = createSelector([selectDbnp], (dbnp) => dbnp.search);

export const selectDbnpItemsCount = createSelector([selectDbnp], (dbnp) => dbnp.count);

export const selectDbnpItemsFilter = createSelector([selectDbnp], (dbnp) => dbnp.filter);